export default __webpack_public_path__ + "static/media/logo.ddf9662c.png";